import { Global } from '@emotion/react'

import { globalStyles, fonts } from 'assets/styles/global'
import AgentContainer from 'components/AgentContainer'
import App from 'components/App'
import { AuthProvider } from 'context/AuthContext'
import theme from 'theme'

export default function Root() {
  return (
    <AuthProvider>
      <Global styles={[globalStyles(theme), fonts]} />
      <AgentContainer />
      <App />
    </AuthProvider>
  )
}
